<div class="sell-verify-address-wrapper p-3">
  <app-shared-input
    for="streetAddress"
    label="Enter your home address"
    icon="location-blue"
    [focused]="focused"
    [value]="streetAddress"
  >
    <input
      #streetAddressInput
      name="streetAddress"
      id="streetAddress"
      type="text"
      (focus)="handleFocus()"
      (blur)="focused = false"
      [(ngModel)]="streetAddress"
      autocomplete="off"
    />
  </app-shared-input>

  <div
    #trigger="matMenuTrigger"
    [matMenuTriggerFor]="addressResults"
    class="-mt-4"
  ></div>
  <mat-menu
    #addressResults
    class="address-search-mat-menu"
    (closed)="clearSelected()"
  >
    <div>
      <ul>
        <ng-container *ngIf="resultsSelected.length > 0">
          <li
            *ngFor="let result of resultsSelected"
            (click)="handleSelect(result)"
          >
            <span class="address">
              {{ result.streetLine }} {{ result.secondary }}, {{ result.city }},
              {{ result.state }}
              {{ result.zipcode }}
            </span>
          </li>
        </ng-container>
        <ng-container *ngIf="resultsSelected.length <= 0">
          <li *ngFor="let result of results" (click)="handleSelect(result)">
            <span class="address">
              {{ result.streetLine }} {{ result.secondary }}, {{ result.city }},
              {{ result.state }}
              {{ result.zipcode }}
            </span>
            <span class="entries" *ngIf="result.entries > 1">
              + {{ result.entries }} addresses
              <app-shared-icon
                name="arrow-left-blue"
                [size]="14"
              ></app-shared-icon>
            </span>
          </li>
        </ng-container>
      </ul>
    </div>
  </mat-menu>
</div>
